// extracted by mini-css-extract-plugin
export default {"price":"BZ-z","onSale":"CZ-z","msrpLabelPrice":"DZ-z","originalPrice":"EZ-z","msrpLabel":"FZ-z","percentOff":"GZ-z"};